// extracted by mini-css-extract-plugin
module.exports = {"problemCellWidth":"24px","problemCellSideMargin":"2px"};